import { render, staticRenderFns } from "./FileFolderAddIcon.vue?vue&type=template&id=3da5306d&"
import script from "./FileFolderAddIcon.vue?vue&type=script&lang=js&"
export * from "./FileFolderAddIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports